module.exports = __webpack_public_path__ + "img/Innovation-Excellence-2023-EN.5a76c9c3.png";